import React from 'react';
import type { PercentileLevel } from '@talentmesh/utils';
import { AnimatedCircularProgressBar } from '@/Components/shadcn/animated-circular-progress-bar';

interface ResultsTalentScoreCircularProgressProps {
    level: PercentileLevel;
    progress?: number;
}

function ResultsTalentScoreCircularProgress({
    level,
    progress,
}: ResultsTalentScoreCircularProgressProps): React.JSX.Element {
    return (
        <AnimatedCircularProgressBar value={progress} level={level} className="size-[50px] text-base font-semibold" />
    );
}

export default ResultsTalentScoreCircularProgress;
